import {
  ApiGetRequest,
  //   ApiPostRequest,
  //   ApiDeleteRequest,
  //   ApiPutRequest,
} from '../../../api';
// import { _ } from 'vue-underscore';
// import { showNotif } from '../notification';

export const state = {
  data: {
    title: 'Setting Klasifikasi Akun',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/fin',
      },
      {
        text: 'Klasifikasi Akun',
        href: '/adm/fin/setting/klasifikasi-akun',
        active: true,
      },
    ],
    akun: [
      {
        id: 1,
        acc_no: 1,
        acc_name: 'Harta',
      },
      {
        id: 2,
        acc_no: 2,
        acc_name: 'Kewajiban',
      },
      {
        id: 3,
        acc_no: 3,
        acc_name: 'Modal',
      },
      {
        id: 4,
        acc_no: 4,
        acc_name: 'Pendapatan',
      },
      {
        id: 5,
        acc_no: 5,
        acc_name: 'Biaya Atas Pendapatan',
      },
      {
        id: 6,
        acc_no: 6,
        acc_name: 'Pengeluaran Operasional',
      },
      {
        id: 7,
        acc_no: 7,
        acc_name: 'Pengeluaran Non Operasional',
      },
      {
        id: 8,
        acc_no: 8,
        acc_name: 'Pendapatan Lain',
      },
      {
        id: 9,
        acc_no: 9,
        acc_name: 'Pengeluaran Lain',
      },
    ],
    akun_level3: [
      {
        id: 1,
        acc_no: 1100,
        acc_name: 'Kas',
      },
      {
        id: 2,
        acc_no: 1200,
        acc_name: 'Bank',
      },
    ],
    akun_level2: [
      {
        id: 1,
        acc_no: 1100,
        acc_name: 'Hutang Lancar',
        mulai: 2100,
        akhir: 2200,
      },
    ],
    items: [],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: '',
    sortDesc: false,
    fields: [
      {
        key: 'project_no',
        label: 'Kode',
        sortable: true,
      },
      {
        key: 'project_name',
        label: 'Nama Proyek',
        sortable: true,
      },
      {
        key: 'manajer',
        label: 'Manajer Proyek',
      },
      {
        key: 'desc_project',
        label: 'Deskripsi',
      },
      {
        key: 'jenis_project',
        label: 'Jenis',
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    form: {},
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
};

export const mutations = {
  settingFinance(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async getKlasifikasi(context, params = null) {
    let result = await ApiGetRequest(`opr/customers`, params);
    return !result.error ? result.data.object : [];
  },
};
